import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "../i18n/I18nContext";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import ProfileForm, { PROFILE_LABELS } from "../components/ProfileForm";
import { Sparkles } from "lucide-react";

export default function ProfileOnboarding() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { language } = useTranslation();
  const lang = PROFILE_LABELS[language] || PROFILE_LABELS.en;

  // If the profile is already complete (or admin), no need to onboard.
  useEffect(() => {
    if (!loading && user && (user.profile_completed || user.role === "admin")) {
      navigate("/dashboard", { replace: true });
    }
  }, [loading, user, navigate]);

  return (
    <div className="min-h-screen bg-neutral-950 py-10 px-4">
      <main className="max-w-xl mx-auto space-y-6">
        <div className="text-center space-y-3">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-red-600/15 text-red-500 mx-auto">
            <Sparkles className="w-7 h-7" />
          </div>
          <h1 className="text-2xl font-bold text-white font-['Nunito']" data-testid="onboarding-title">
            {user?.full_name ? `${user.full_name.split(" ")[0]} 👋` : "👋"}
          </h1>
        </div>

        <Card className="border-0 shadow-lg bg-neutral-900 border-neutral-800">
          <CardHeader>
            <CardTitle className="text-white text-base md:text-lg font-['Nunito'] leading-relaxed">
              {lang.intro}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ProfileForm
              submitLabelKey="complete"
              onSaved={() => navigate("/dashboard", { replace: true })}
            />
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
